import React from "react";
import { TextField, Box, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const BRAND_BLUE = "#00336C";
const BRAND_GREEN = "#648315";

export default function TradeShowSearch({
  value,
  onChange,
  onEnter,
  maxWidth = 1500,
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && typeof onEnter === "function") {
      onEnter();
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <Box sx={{ width: "100%", maxWidth }}>
        <TextField
          placeholder="Search Trade Shows Name, Location, or Industry..."
          variant="outlined"
          fullWidth
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: BRAND_BLUE }} />
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "40px",
              backgroundColor: "#ffffff",
              transition: "all 0.3s ease",
              "& fieldset": {
                borderColor: BRAND_BLUE,
                borderWidth: 1.8,
              },
              "&:hover fieldset": {
                borderColor: BRAND_GREEN,
                boxShadow: "0 0 8px rgba(0, 51, 108, 0.15)",
              },
              "&.Mui-focused fieldset": {
                borderColor: BRAND_BLUE,
                borderWidth: 2,
                boxShadow: "0 0 10px rgba(0, 51, 108, 0.3)",
              },
            },
            "& input": {
              fontSize: "1.1rem",
              py: 1.5,
            },
            "& .MuiInputAdornment-root": {
              ml: 1,
            },
          }}
        />
      </Box>
    </Box>
  );
}
